import { render, staticRenderFns } from "./Music4Icon.vue?vue&type=template&id=b9d0a3c0"
import script from "./Music4Icon.vue?vue&type=script&lang=js"
export * from "./Music4Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports